<template>
  <div class="details">
    <QS-scroller-box>
      <!-- 详情页 -->
      <div class="details_content">
        <div class="details_content_title">
          <QS-h3-title class="purchase">
            <template slot="title"
              >采购订单关闭</template
            >
          </QS-h3-title>
        </div>
        <div class="splitline mt16 mb16" />
        <!-- 采购订单基本信息 -->
        <div class="details_content_repeat">
          <QS-h4-title title="订单信息" />
          <purchase-baseInfo :baseInfo="baseInfo" />
        </div>
        <!-- 退车变更信息 -->
        <tcbg-table :tableData="carBackInfo" />
        <!-- 采购订单关闭结算 -->
        <div class="details_content_repeat">
          <QS-h4-title title="订单关闭类型" />
          <div class="details_content_repeat_hundred" style="width: 600px">
            <el-form
              label-width="140px"
              :rules="close_information_rules"
              :model="closeInfo"
              ref="closeForm"
            >
              <el-form-item
                required
                :label="'订单关闭类型' + columnSeparator"
                prop="closeType"
                class="enclosure alone"
              >
                <div>
                  <el-select
                    v-model="closeInfo.closeType"
                    clearable
                    placeholder="请选择订单关闭类型"
                  >
                    <el-option
                      v-for="item in closeType_options"
                      :key="'closeType_options' + item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item
                :label="'备注' + columnSeparator"
                prop="closeRemarks"
                class="enclosure alone"
              >
                <div>
                  <el-input
                    type="textarea"
                    v-model.trim="closeInfo.closeRemarks"
                    :maxlength="300"
                    show-word-limit
                    placeholder="请输入备注"
                    clearable
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- --结束 采购订单关闭结算 -->
      </div>
      <template slot="bottomAction">
        <el-button size="mini" @click="cancelEdit">取消</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="confirmCloseFn"
          :loading="btnLoading"
          >确认关闭订单</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
import tcbgTable from '../../components/tcbgTable.vue'
import purchaseBaseInfo from '../../components/purchaseBaseInfo.vue'
import selectOption from '@/store/dict/selectOptionDict'
// eslint-disable-next-line import/no-cycle
import { getPurchaseDetail, purchaseCloseOrder } from '@/api/domain/purchase.js'

export default {
  components: {
    purchaseBaseInfo,
    tcbgTable,
  },
  data() {
    return {
      detailsId: null, // 当前订单ID
      btnLoading: false,
      carBackInfo: [], // 车辆信息
      baseInfo: {}, // 采购订单基本信息
      closeInfo: {
        id: '', // ID，必填
        closeType: '', // 订单关闭类型  1提前解约/2合同到期,必填
        closeRemarks: '', // 备注
      },
      closeType_options: [
        {
          value: 2,
          label: '提前解约',
        },
        {
          value: 3,
          label: '到期解约',
        },
      ],
      close_information_rules: {
        // 订单关闭类型
        closeType: [
          {
            required: true,
            message: '订单关闭类型不能为空',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    const { id } = this.$route.query
    if (!id) {
      this.$message.error('请携带必要参数')
      this.$router.go(-1)
    }
    this.detailsId = String(id)
    this.getDetails() // 获取采购订单详情
  },
  methods: {
    // 详情页请求数据
    async getDetails() {
      const { code, data } = await getPurchaseDetail({
        id: this.detailsId,
      })
      if (code === 1) {
        this.baseInfo = data.orderInfo || {} // 采购订单基本信息
        this.carBackInfo = data.carInfoList || [] // 车辆信息
        this.carBackInfo.forEach((item, index) => {
          item.index = index + 1
          return item
        })
        this.handle()
      }
    },
    // 处理数据---把1,2,3,4转换成对应的文字
    handle() {
      // 订单类型
      const purchaseMode =
        selectOption.purchaseTypeDict[this.baseInfo.purchaseMode] // 采购方式：1购买/2租赁
      const state = selectOption.purchaseStateDict[this.baseInfo.state] // 订单状态：2进行中/4已关闭
      const contractAttachment = this.getEchoUploadFileData(
        this.baseInfo.contractAttachment,
        true,
      ) // 合同附件
      this.baseInfo = {
        ...this.baseInfo,
        purchaseMode,
        state,
        contractAttachment,
      }
    },
    // 关闭订单
    confirmCloseFn() {
      this.btnLoading = true
      this.closeInfo.id = this.detailsId
      this.$refs.closeForm.validate(async (valid) => {
        if (valid) {
          const { code } = await purchaseCloseOrder(this.closeInfo)
          this.btnLoading = false
          if (code === 1) {
            this.$message.success('订单关闭成功')
            this.$refreshBack(true)
            this.$router.push('/purchaseNew/purchaseOrder/list')
          }
        } else {
          this.btnLoading = false
        }
      })
    },
    cancelEdit() {
      this.$refreshBack(false)
      this.$router.push({ path: '/purchaseNew/purchaseOrder/list' })
    },
  },
}
</script>
<style lang="scss" scoped>
.details {
  .details_content {
    .details_content_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .purchase {
        margin: 0;
      }
      h3 {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #323233;
        font-weight: 500;
        margin: 0;
      }
    }
    .details_content_repeat {
      margin-bottom: 16px;
      ::v-deep .qs-h4-container-left {
        font-size: 16px;
      }
      .details_content_repeat_hundred {
        // margin-left: 100px;
        ::v-deep .column-title {
          text-align: right;
          padding-right: 10px;
          color: #333333;
          min-width: 115px !important;
        }
        .enclosure {
          ::v-deep .el-form-item__label {
            width: 117px !important;
          }
        }
      }
    }
    // 文件图标颜色
    .uptext {
      .blue {
        color: #2e7eff;
        display: inline-block;
        margin: 0;
      }
    }
  }
  .i-title-box {
    position: relative;
    .i-title-btn {
      position: absolute;
      top: 4px;
      right: 0;
    }
  }
  .txt-right {
    text-align: right;
  }
}
</style>
